export default "__VITE_ASSET__CrDsrIIv__"